import { Component } from '@angular/core';
import { LiteralService, ServiceWizardService } from 'src/app/services';

@Component({
  selector: 'app-wizard-step-buttons',
  templateUrl: './wizard-step-buttons.component.html',
  standalone: false
})
export class WizardStepButtonsComponent {

  constructor(public literalService: LiteralService,
              public serviceWizardService: ServiceWizardService) { }

}
